module.exports = __webpack_public_path__ + "static/media/long_term_stay.70e87204.svg";